module.exports = __webpack_public_path__ + "static/media/iconAddTrading.3de83e60.svg";